<script setup>
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14" fill="none">
        <path
            d="M12.8243 13.1515C12.6738 12.4356 11.4942 7.95453 6.42473 7.95453C0.92859 7.95453 0.0251151 13.2045 1.8605e-05 13.2576C-0.0250779 13.3901 1.86088e-05 13.4962 0.100405 13.6023C0.175694 13.7083 0.301177 13.7613 0.401563 13.7613H12.4479C12.6738 13.7613 12.8494 13.5757 12.8494 13.3371C12.8494 13.2576 12.8494 13.2045 12.8243 13.1515ZM0.92859 12.8863C1.27994 11.6932 2.53477 8.7765 6.42473 8.7765C10.3147 8.7765 11.5695 11.6666 11.9209 12.8863H0.92859Z"
            fill="#474CE6" />
        <path
            d="M6.4248 7.15912C8.23175 7.15912 9.71245 5.59473 9.71245 3.65912C9.71245 1.72351 8.23175 0.159119 6.4248 0.159119C4.61785 0.159119 3.11206 1.72351 3.11206 3.65912C3.11206 5.59473 4.59276 7.15912 6.4248 7.15912ZM6.4248 1.03412C7.80511 1.03412 8.90936 2.2273 8.90936 3.65912C8.90936 5.11745 7.78001 6.28412 6.4248 6.28412C5.04449 6.28412 3.94025 5.09094 3.94025 3.65912C3.91515 2.20079 5.04449 1.03412 6.4248 1.03412Z"
            fill="#474CE6" />
    </svg>
</template>

<style lang="scss" scoped></style>